import { render, staticRenderFns } from "./paginate.vue?vue&type=template&id=6a76fd07&scoped=true"
import script from "./paginate.vue?vue&type=script&lang=js"
export * from "./paginate.vue?vue&type=script&lang=js"
import style0 from "./paginate.vue?vue&type=style&index=0&id=6a76fd07&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a76fd07",
  null
  
)

export default component.exports